module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAABCElEQVQYV23QP0tCYRQG8Oc595W6RAaSUvQZgra4LRW3pYhoaSgkGoKcHPoE9wvY1NDQ0OAk1FA4RIW56NTWEjTeyeyCQYRE94Qv1FXxjIff+Uv0ha6X0zDpEOJMQgwg5pmX/nyP8M/pRmUGyhCtyOXT0Xcvr7u1aXTjN175TOBaOeZ9XvonWLxzN4XYeUygf/HJh4OJYWjx9q0mcPW8xdphbiTcqioVgRBBrMtnynrhv3DgyM3rDtUrRRCTB8c/4Ogp64WFwU9UOvjCnO2gXukdYjIwY0sAGhDzYl/E1CxcyfFmr21HY9H9gZgITO2zUayO2pO6EhiEGYevxa56J200j7MEdBj/AjkJVNXDLCTUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/13.png
// module id = A34k
// module chunks = 1